import AppIcon from "@components/AppIcon";
import AppImage from "@components/AppImage";
import Locale from "@components/core/Locale";
import clx from "classnames";
import { memo } from "react";

const MiniSidebarItem = ({ icon, active, notification, onClick, media, title, isExpanded }) => {
  return (
    <div
      onClick={onClick}
      className={clx("flex h-16 px-4 w-full items-center text-fg cursor-pointer relative", {
        "bg-bg-dark": active,
        "bg-card hover:bg-bg-light": !active,
        "justify-center": !isExpanded,
      })}
    >
      {media ? <AppImage code={media} className="w-12 h-10 object-contain" /> : <AppIcon code={icon} className="w-6 flex-shrink-0" aria-hidden="true" />}
      {isExpanded && (
        <span className="ml-4 text-base leading-tight font-medium truncate">
          <Locale code={title} />
        </span>
      )}
      {notification && <span className={`w-4 h-4 text-primary absolute ${isExpanded ? "right-4" : "top-2 right-1"}`}>●</span>}
    </div>
  );
};

export default memo(MiniSidebarItem);
